import { history } from './router'

export const pushRoute = (pathToNavigateTo: string, resetParams = false) => {
  if (resetParams) {
    window.location.replace(pathToNavigateTo)
  }

  const currentUrl = new URL(window.location.href)

  currentUrl.pathname = pathToNavigateTo

  history.push(currentUrl.toString())
}
